import { render, staticRenderFns } from "./viewProperties.vue?vue&type=template&id=269b03b9&scoped=true"
import script from "./viewProperties.vue?vue&type=script&lang=js"
export * from "./viewProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269b03b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('269b03b9')) {
      api.createRecord('269b03b9', component.options)
    } else {
      api.reload('269b03b9', component.options)
    }
    module.hot.accept("./viewProperties.vue?vue&type=template&id=269b03b9&scoped=true", function () {
      api.rerender('269b03b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/product-details/components/physicalModel/viewProperties.vue"
export default component.exports